<script setup lang="ts">
import type { BadgeProps } from '@nuxt/ui'
import type { ArtifactStatus } from '@/types'
import { computed } from 'vue'

const props = defineProps<{
  status: ArtifactStatus
}>()

const config = computed<{ label: string, color: BadgeProps['color'], icon: string }>(() => {
  switch (props.status) {
    case 'ready':
      return { label: 'Ready', color: 'success', icon: 'i-lucide-check-circle' }
    case 'failed':
      return { label: 'Failed', color: 'error', icon: 'i-lucide-x-circle' }
    default:
      return { label: 'Verifying', color: 'warning', icon: 'i-lucide-loader-circle' }
  }
})
</script>

<template>
  <UBadge :color="config.color" variant="subtle" size="sm">
    <UIcon
      :name="config.icon"
      :class="status === 'verifying' ? 'animate-spin' : ''"
    />
    {{ config.label }}
  </UBadge>
</template>
